"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ResponsiveImage = _interopRequireDefault(require("./../../utils/ResponsiveImage"));
var _PageHeroModule = _interopRequireDefault(require("./../../../scss/layout-wrappers/PageHero.module.scss"));
function ImageOnlyHero({
  fullSizeImage,
  mobileImage = {
    url: '',
    dimensions: {
      width: 0,
      height: 0
    }
  },
  fullSizeImagePosition = [50, 50],
  mobileImagePosition = [50, 50]
}) {
  var _fullSizeImagePositio, _fullSizeImagePositio2, _mobileImagePosition$, _mobileImagePosition$2;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _PageHeroModule.default['hero'],
    style: {
      '--background-image-position': `${(_fullSizeImagePositio = fullSizeImagePosition === null || fullSizeImagePosition === void 0 ? void 0 : fullSizeImagePosition[0]) !== null && _fullSizeImagePositio !== void 0 ? _fullSizeImagePositio : '50'}% ${(_fullSizeImagePositio2 = fullSizeImagePosition === null || fullSizeImagePosition === void 0 ? void 0 : fullSizeImagePosition[1]) !== null && _fullSizeImagePositio2 !== void 0 ? _fullSizeImagePositio2 : '50'}%`,
      '--mobile-background-image-position': `${(_mobileImagePosition$ = mobileImagePosition === null || mobileImagePosition === void 0 ? void 0 : mobileImagePosition[0]) !== null && _mobileImagePosition$ !== void 0 ? _mobileImagePosition$ : '50'}% ${(_mobileImagePosition$2 = mobileImagePosition === null || mobileImagePosition === void 0 ? void 0 : mobileImagePosition[1]) !== null && _mobileImagePosition$2 !== void 0 ? _mobileImagePosition$2 : '50'}%`
    }
  }, mobileImage.url !== '' && /*#__PURE__*/_react.default.createElement("img", {
    className: _PageHeroModule.default['mobile-background-image'],
    src: mobileImage.url,
    alt: ""
  }), /*#__PURE__*/_react.default.createElement(_ResponsiveImage.default, {
    fullSizeUrl: fullSizeImage.url,
    sources: fullSizeImage.sources,
    classname: _PageHeroModule.default['background-image']
  }));
}
var _default = exports.default = ImageOnlyHero;